import { render, staticRenderFns } from "./address-suggestion.vue?vue&type=template&id=274b89ae&"
import script from "./address-suggestion.vue?vue&type=script&lang=js&"
export * from "./address-suggestion.vue?vue&type=script&lang=js&"
import style0 from "./address-suggestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports